var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Defaults from '../Defaults';
import { MenuTargets } from '../Constants';
import { UploadFileFormModel } from '.';
var defaults = Defaults.MenuSetting;
var TemporaryCustomGeoMenuSettingFormModel = /** @class */ (function () {
    function TemporaryCustomGeoMenuSettingFormModel(item) {
        if (item === void 0) { item = {}; }
        var _a = item, id = _a.id, _b = _a.orderDescription, orderDescription = _b === void 0 ? {} : _b, uploadFile = _a.uploadFile;
        var _c = orderDescription, _d = _c.target, target = _d === void 0 ? defaults.target : _d, _e = _c.minutesAgo, minutesAgo = _e === void 0 ? defaults.minutesAgo : _e, _f = _c.visitCount, visitCount = _f === void 0 ? defaults.visitCount : _f, _g = _c.useS2, useS2 = _g === void 0 ? true : _g, _h = _c.memo, memo = _h === void 0 ? '' : _h;
        this.id = id;
        this.orderDescription = {
            target: target,
            minutesAgo: minutesAgo,
            visitCount: visitCount,
            useS2: useS2,
            memo: memo,
        };
        this.uploadFile = UploadFileFormModel.assign(uploadFile);
    }
    TemporaryCustomGeoMenuSettingFormModel.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/];
            });
        });
    };
    Object.defineProperty(TemporaryCustomGeoMenuSettingFormModel.prototype, "isSimulatable", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TemporaryCustomGeoMenuSettingFormModel.prototype, "targetCode", {
        get: function () {
            return this.orderDescription.target;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TemporaryCustomGeoMenuSettingFormModel.prototype, "isOnlyResident", {
        get: function () {
            return (this.orderDescription.target.length === 1 &&
                this.orderDescription.target.includes(MenuTargets.RESIDENT));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TemporaryCustomGeoMenuSettingFormModel.prototype, "isNew", {
        get: function () {
            return this.id == null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TemporaryCustomGeoMenuSettingFormModel.prototype, "emptyVisitCountViolation", {
        get: function () {
            return (this.orderDescription.target.includes(MenuTargets.VISITOR) &&
                typeof this.orderDescription.visitCount === 'undefined');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TemporaryCustomGeoMenuSettingFormModel.prototype, "zeroVisitCountViolation", {
        get: function () {
            return (this.orderDescription.target.includes(MenuTargets.VISITOR) &&
                this.orderDescription.visitCount < 1);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TemporaryCustomGeoMenuSettingFormModel.prototype, "emptyMinutesAgoViolation", {
        get: function () {
            return this.orderDescription.minutesAgo == null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TemporaryCustomGeoMenuSettingFormModel.prototype, "minusMinutesAgoViolation", {
        get: function () {
            return this.orderDescription.minutesAgo < 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TemporaryCustomGeoMenuSettingFormModel.prototype, "noTargetViolation", {
        get: function () {
            return this.orderDescription.target.length === 0;
        },
        enumerable: false,
        configurable: true
    });
    TemporaryCustomGeoMenuSettingFormModel.prototype.coerceUseS2State = function () {
        if (!this.availableUseS2) {
            this.orderDescription.useS2 = false;
        }
    };
    TemporaryCustomGeoMenuSettingFormModel.prototype.setTargetCode = function (target) {
        this.orderDescription.target = target;
    };
    Object.defineProperty(TemporaryCustomGeoMenuSettingFormModel.prototype, "availableUseS2", {
        get: function () {
            return !(this.orderDescription.minutesAgo === 0 || this.isOnlyResident);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TemporaryCustomGeoMenuSettingFormModel.prototype, "validations", {
        get: function () {
            return {
                advanced: {
                    required: function (value) {
                        return Boolean(value !== undefined && value !== '') || '入力して下さい';
                    },
                    overZero: function (value) { return Number(value) >= 0 || '0以上の数値を入力して下さい'; },
                    overOne: function (value) { return Number(value) >= 1 || '1以上の数値を入力して下さい'; },
                    integer: function (value) {
                        return Number.isInteger(Number(value)) || '整数で入力して下さい';
                    },
                    withinOneYear: function (value) {
                        return Number(value) <= 365 || '365日よりも前は指定できません';
                    },
                },
            };
        },
        enumerable: false,
        configurable: true
    });
    return TemporaryCustomGeoMenuSettingFormModel;
}());
export { TemporaryCustomGeoMenuSettingFormModel };
